import type { CSSObject } from "type/tss";
import { Theme, alpha } from "@mui/material/styles";
import { baseColors } from "theme";

export const styles = (theme: Theme) => {
	return {
		root: {
			// Orange hover, as on Search > General; the default primary color hovered teal (MAX-4356).
			"&:hover": {
				color: theme.palette.custom.primary,
				backgroundColor: alpha(theme.palette.custom.primary, 0.04),
			},
			"&.Mui-checked": {
				color: theme.palette.custom.primary,
			},
			"&.Mui-disabled": {
				color: baseColors.gray200,
			},
		},
	} satisfies Record<string, CSSObject>;
};
